export const indWVsIreW = {
  _id: '63f0d1accd82c2527e625fe8',
  apiMatchId: '60071',
  competition: {
    cid: 127303,
    title: "ICC Women's T20 World Cup",
    abbr: 'ICCWT20W',
    type: 'tournament',
    category: 'women',
    match_format: 'woment20',
    season: '2023',
    status: 'live',
    datestart: '2023-02-10',
    dateend: '2023-02-26',
    country: 'int',
    total_matches: '23',
    total_rounds: '1',
    total_teams: '10'
  },
  createdOn: '2023-02-18T13:25:00.477Z',
  endDate: '2023-02-20T23:00:00.000Z',
  formatString: 'Women T20',
  gameState: 0,
  gameStateText: 'Default',
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-02-20T13:00:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '18th Match, Group B',
  teamA: {
    team_id: 9536,
    name: 'India Women',
    short_name: 'IND-W',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/India.png'
  },
  teamB: {
    team_id: 10511,
    name: 'Ireland Women',
    short_name: 'IRE-W',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Ireland.png'
  },
  timestampEnd: 1676934000,
  timestampStart: 1676898000,
  title: 'India Women vs Ireland Women',
  venue: {
    venue_id: '62',
    name: "St George's Park, Port Elizabeth",
    location: 'Port Elizabeth',
    country: 'South Africa',
    timezone: ''
  },
  verified: false,
  isQuestionListed: true,
  isContestListed: true,
  isPublished: true
};
export const kolVsLsg = {
  _id: '628240bd6d0713b9cf82d75c',
  apiMatchId: '53392',
  competition: {
    cid: 123213,
    title: 'Indian Premier League',
    abbr: 'IPL',
    type: 'tournament',
    category: 'domestic',
    match_format: 't20',
    status: 'live',
    season: '2022',
    datestart: '2022-03-26',
    dateend: '2022-05-29',
    country: 'in',
    total_matches: '74',
    total_rounds: '1',
    total_teams: '10'
  },
  createdOn: '2022-05-16T12:17:00.655Z',
  endDate: '2022-05-19T00:00:00.000Z',
  formatString: 'T20',
  gameState: 0,
  gameStateText: 'Default',
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2022-05-18T14:00:00.000Z',
  status: 2,
  statusText: 'Completed',
  subtitle: 'Match 66',
  teamA: {
    team_id: 591,
    name: 'Kolkata Knight Riders',
    short_name: 'KKR',
    logo_url: 'https://images.entitysport.com/assets/uploads/2021/03/KKR-Logo.png'
  },
  teamB: {
    team_id: 123214,
    name: 'Lucknow Super Giants',
    short_name: 'LSG',
    logo_url: 'https://images.entitysport.com/assets/uploads/2022/03/Lucknow-Super-Giantslogo.png'
  },
  timestampEnd: 1652918400,
  timestampStart: 1652882400,
  title: 'Kolkata Knight Riders vs Lucknow Super Giants',
  venue: {
    venue_id: '334',
    name: 'Dr DY Patil Sports Academy, Mumbai',
    location: 'Mumbai',
    timezone: '-12'
  },
  verified: true,
  isQuestionListed: true,
  isContestListed: true,
  isPublished: true,
  modifiedOn: '2022-05-18T17:58:00.023Z',
  adminVerified: true
};
export const punVsDc = {
  _id: '627fbf7d6d0713b9cf388229',
  apiMatchId: '53390',
  competition: {
    cid: 123213,
    title: 'Indian Premier League',
    abbr: 'IPL',
    type: 'tournament',
    category: 'domestic',
    match_format: 't20',
    status: 'live',
    season: '2022',
    datestart: '2022-03-26',
    dateend: '2022-05-29',
    country: 'in',
    total_matches: '74',
    total_rounds: '1',
    total_teams: '10'
  },
  createdOn: '2022-05-14T14:41:00.898Z',
  endDate: '2022-05-17T00:00:00.000Z',
  formatString: 'T20',
  gameState: 3,
  gameStateText: 'Play Ongoing',
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2022-05-16T14:00:00.000Z',
  status: 3,
  statusText: 'Live',
  subtitle: 'Match 64',
  teamA: {
    team_id: 627,
    name: 'Punjab Kings',
    short_name: 'PBKS',
    logo_url: 'https://images.entitysport.com/assets/uploads/2021/03/PK-Logo.png'
  },
  teamB: {
    team_id: 612,
    name: 'Delhi Capitals',
    short_name: 'DC',
    logo_url: 'https://images.entitysport.com/assets/uploads/2021/03/DC-Logo.png'
  },
  timestampEnd: 1652745600,
  timestampStart: 1652709600,
  title: 'Punjab Kings vs Delhi Capitals',
  venue: {
    venue_id: '334',
    name: 'Dr DY Patil Sports Academy, Mumbai',
    location: 'Mumbai',
    timezone: '-12'
  },
  verified: false,
  isQuestionListed: true,
  isContestListed: true,
  isPublished: true,
  modifiedOn: '2022-05-16T18:00:00.054Z',
  adminVerified: true
};
